package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.ShareW500Rounded: ImageVector
    get() {
        if (_shareW500Rounded != null) {
            return _shareW500Rounded!!
        }
        _shareW500Rounded = Builder(name = "ShareW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(680.94f, 888.13f)
                quadToRelative(-53.09f, 0.0f, -90.24f, -37.09f)
                quadToRelative(-37.16f, -37.09f, -37.16f, -90.08f)
                quadToRelative(0.0f, -5.76f, 2.76f, -25.85f)
                lineTo(283.43f, 576.13f)
                quadToRelative(-16.71f, 14.76f, -38.17f, 23.14f)
                reflectiveQuadToRelative(-45.98f, 8.38f)
                quadToRelative(-53.09f, 0.0f, -90.25f, -37.21f)
                quadToRelative(-37.16f, -37.22f, -37.16f, -90.38f)
                quadToRelative(0.0f, -53.17f, 37.16f, -90.44f)
                quadToRelative(37.16f, -37.27f, 90.25f, -37.27f)
                quadToRelative(24.48f, 0.0f, 46.2f, 8.5f)
                quadToRelative(21.72f, 8.5f, 38.67f, 23.5f)
                lineToRelative(271.92f, -158.5f)
                quadToRelative(-1.77f, -6.52f, -2.15f, -12.9f)
                quadToRelative(-0.38f, -6.38f, -0.38f, -13.67f)
                quadToRelative(0.0f, -53.09f, 37.17f, -90.25f)
                reflectiveQuadToRelative(90.26f, -37.16f)
                quadToRelative(53.1f, 0.0f, 90.25f, 37.17f)
                quadToRelative(37.15f, 37.16f, 37.15f, 90.26f)
                quadToRelative(0.0f, 53.09f, -37.16f, 90.24f)
                quadToRelative(-37.16f, 37.16f, -90.25f, 37.16f)
                quadToRelative(-25.05f, 0.0f, -46.96f, -8.74f)
                reflectiveQuadToRelative(-38.87f, -24.22f)
                lineTo(324.17f, 451.28f)
                quadToRelative(2.0f, 7.25f, 2.5f, 13.99f)
                quadToRelative(0.5f, 6.73f, 0.5f, 14.85f)
                reflectiveQuadToRelative(-0.62f, 15.1f)
                quadToRelative(-0.62f, 6.98f, -2.62f, 14.21f)
                lineToRelative(270.72f, 157.55f)
                quadToRelative(16.96f, -15.72f, 39.02f, -24.7f)
                quadToRelative(22.07f, -8.98f, 47.29f, -8.98f)
                quadToRelative(53.09f, 0.0f, 90.25f, 37.22f)
                reflectiveQuadToRelative(37.16f, 90.38f)
                quadToRelative(0.0f, 53.17f, -37.17f, 90.2f)
                quadToRelative(-37.16f, 37.03f, -90.26f, 37.03f)
                close()
                moveTo(680.81f, 799.52f)
                quadToRelative(16.43f, 0.0f, 27.69f, -11.16f)
                quadToRelative(11.26f, -11.16f, 11.26f, -27.66f)
                reflectiveQuadToRelative(-11.22f, -27.65f)
                quadToRelative(-11.23f, -11.14f, -27.82f, -11.14f)
                quadToRelative(-16.39f, 0.0f, -27.48f, 11.26f)
                reflectiveQuadToRelative(-11.09f, 27.55f)
                quadToRelative(0.0f, 16.28f, 11.12f, 27.54f)
                quadToRelative(11.11f, 11.26f, 27.54f, 11.26f)
                close()
                moveTo(199.3f, 519.04f)
                quadToRelative(16.5f, 0.0f, 27.88f, -11.21f)
                quadToRelative(11.39f, -11.21f, 11.39f, -27.78f)
                reflectiveQuadToRelative(-11.39f, -27.83f)
                quadToRelative(-11.38f, -11.26f, -27.88f, -11.26f)
                reflectiveQuadToRelative(-27.66f, 11.21f)
                quadToRelative(-11.16f, 11.21f, -11.16f, 27.78f)
                reflectiveQuadToRelative(11.16f, 27.83f)
                quadToRelative(11.16f, 11.26f, 27.66f, 11.26f)
                close()
                moveTo(708.38f, 226.97f)
                quadToRelative(11.14f, -11.11f, 11.14f, -27.54f)
                reflectiveQuadToRelative(-11.11f, -27.69f)
                quadToRelative(-11.12f, -11.26f, -27.55f, -11.26f)
                reflectiveQuadToRelative(-27.69f, 11.22f)
                quadToRelative(-11.26f, 11.23f, -11.26f, 27.82f)
                quadToRelative(0.0f, 16.39f, 11.38f, 27.48f)
                reflectiveQuadToRelative(27.67f, 11.09f)
                quadToRelative(16.28f, 0.0f, 27.42f, -11.12f)
                close()
                moveTo(681.2f, 760.72f)
                close()
                moveTo(199.52f, 480.0f)
                close()
                moveTo(680.96f, 199.28f)
                close()
            }
        }
        .build()
        return _shareW500Rounded!!
    }

private var _shareW500Rounded: ImageVector? = null
